import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourseaterbusonrentinshirdi() {



    const cardData = {





keyword: "45 Seater Bus on Rent in Shirdi",
headingDescription: "Sai Shirdi Cab offers 45 seater bus rental in Shirdi for large groups that need dependable and well-organized transportation for outstation journeys. A 45 seater bus is a suitable choice for school and college tours, pilgrimage groups, corporate outings, wedding functions, social events, family vacations, tour operators, and multi-day group travel. Traveling in one high-capacity bus helps keep the entire group together while simplifying pickup, route coordination, luggage arrangements, and return travel. Sai Shirdi Cab can arrange 45 seater bus hire from Shirdi for one-way trips, round trips, sightseeing programs, multi-destination tours, and customized itineraries across Maharashtra and nearby states. Whether the requirement is for a short group excursion or a longer interstate journey, the bus rental can be planned around the passenger count, travel schedule, and selected destination.",

topPlaces: [
{
title: "Goa",
description: "Goa is a strong choice for large groups traveling from Shirdi for vacations, college tours, family holidays, celebrations, and organized group trips. A 45 seater bus provides ample seating for bigger groups and allows passengers to remain together throughout the long journey. Sai Shirdi Cab can arrange one-way, round-trip, or multi-day bus travel with a route plan suited to the group's itinerary and sightseeing requirements."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a suitable outstation destination for pilgrimage groups and families departing from Shirdi. With a 45 seater bus on rent, devotees and organized tour groups can travel together without coordinating multiple smaller vehicles. Sai Shirdi Cab can arrange group transportation for temple visits, return journeys, and extended pilgrimage programs covering additional destinations."
},
{
title: "Igatpuri",
description: "Igatpuri offers a convenient option for large family groups, corporate teams, student groups, and leisure travelers planning a nature-focused trip from Shirdi. A 45 seater bus makes group travel easier by keeping passengers together and providing a single coordinated vehicle for the journey. Sai Shirdi Cab can organize transportation around sightseeing stops, group pickup points, and return schedules."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves are ideal for educational tours, heritage trips, family outings, and cultural group journeys from Shirdi. A 45 seater bus provides the capacity required for larger groups visiting historical attractions together. Sai Shirdi Cab can arrange direct transportation or a customized sightseeing itinerary that includes other heritage and pilgrimage destinations around Chhatrapati Sambhajinagar."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill-station option for groups planning a longer leisure trip from Shirdi. A 45 seater bus can accommodate large families, friends, corporate groups, and organized tour parties in one vehicle. Sai Shirdi Cab can plan round-trip or multi-day travel with convenient group transportation for sightseeing around the hill station and nearby areas."
},
{
title: "Saptashrungi",
description: "Saptashrungi can be included in a religious group itinerary from Shirdi, particularly for devotees traveling in larger numbers. Hiring a 45 seater bus helps simplify the journey by providing shared transportation and a coordinated travel schedule. Sai Shirdi Cab can support group pilgrimage plans with suitable pickup arrangements, destination travel, and return transportation."
},
{
title: "Pune",
description: "Pune is an important outstation destination for corporate groups, educational tours, family travel, events, and organized excursions from Shirdi. A 45 seater bus rental offers an efficient solution when a large number of passengers need to reach Pune together. Sai Shirdi Cab can arrange one-way or return transportation and customize the journey around the group's departure and arrival requirements."
},
{
title: "Bhandardara",
description: "Bhandardara is well suited for large groups looking for a peaceful nature getaway from Shirdi. Families, friends, corporate teams, and tour groups can hire a 45 seater bus to keep everyone together during the trip. Sai Shirdi Cab can arrange comfortable group transportation for sightseeing, overnight stays, weekend tours, and return journeys based on the planned travel schedule."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a practical destination for large pilgrimage groups traveling from Shirdi. A 45 seater bus gives devotees and families the convenience of shared travel while reducing the complexity of coordinating several vehicles. Sai Shirdi Cab can organize transportation for direct temple visits, group excursions, and combined religious routes across Maharashtra."
},
{
title: "Nashik",
description: "Nashik provides a flexible outstation route from Shirdi for pilgrimage tours, family groups, corporate visits, and sightseeing programs. For larger parties, a 45 seater bus allows passengers to travel together under one coordinated itinerary. Sai Shirdi Cab can arrange group bus rental for direct Nashik travel or customized routes that combine Nashik with nearby religious, cultural, and leisure destinations."
}
],









"services": [
{
"name": "45 Seater Bus on Rent in Shirdi",
"description": "45 Seater Bus on Rent in Shirdi is a suitable transportation option for large groups traveling for sightseeing, pilgrimages, family tours, events, and outstation journeys. The bus can be arranged according to the required route, travel date, pickup point, passenger count, luggage needs, and journey duration."
},
{
"name": "45 Seater Bus Rental Shirdi",
"description": "45 Seater Bus Rental Shirdi provides spacious group transportation for families, tour groups, schools, companies, and event organizers. Customers can plan convenient travel with suitable pickup and drop locations along with flexible one-way, round-trip, or customized journey options."
},
{
"name": "45 Seater Bus Hire Shirdi",
"description": "45 Seater Bus Hire Shirdi offers a practical solution for transporting a large number of passengers together. It can be used for local sightseeing, religious tours, corporate programs, weddings, school outings, social functions, and long-distance travel."
},
{
"name": "45 Seater Tourist Bus Shirdi",
"description": "45 Seater Tourist Bus Shirdi is designed for organized group tours and sightseeing trips starting from Shirdi. The spacious seating arrangement allows travelers to stay together while visiting tourist attractions, pilgrimage destinations, and multiple locations during a planned itinerary."
},
{
"name": "45 Seater Bus Booking Shirdi",
"description": "45 Seater Bus Booking Shirdi makes group transportation planning easier for scheduled trips and special occasions. Travelers can provide their journey details, including pickup location, destination, travel date, passenger requirements, and preferred one-way or return service."
},
{
"name": "45 Seater Bus with Driver Shirdi",
"description": "45 Seater Bus with Driver Shirdi provides chauffeur-driven transportation for groups that prefer a convenient and organized journey. A dedicated driver manages the driving requirements while passengers can travel together comfortably for sightseeing, functions, pilgrimages, and outstation trips."
},
{
"name": "45 Seater Bus for Outstation Shirdi",
"description": "45 Seater Bus for Outstation Shirdi is suitable for large groups traveling from Shirdi to different cities and destinations. The service can be planned for extended routes, multiple stops, sightseeing tours, pilgrimage journeys, family vacations, and return trips."
},
{
"name": "45 Seater Bus for Family Trip Shirdi",
"description": "45 Seater Bus for Family Trip Shirdi gives larger families and groups the convenience of traveling together in one spacious vehicle. It is useful for holiday tours, temple visits, sightseeing plans, family functions, and outstation trips requiring comfortable group transportation."
},
{
"name": "45 Seater Bus for Wedding Shirdi",
"description": "45 Seater Bus for Wedding Shirdi helps families arrange transportation for wedding guests, relatives, and other groups. It can be used for transfers between hotels, wedding halls, ceremony venues, reception locations, railway stations, and other destinations connected with the event."
},
{
"name": "45 Seater Bus for Corporate Trip Shirdi",
"description": "45 Seater Bus for Corporate Trip Shirdi is a convenient choice for companies arranging employee transportation, team outings, conferences, meetings, training programs, and business events. Travel schedules can be coordinated according to office timings, pickup points, destinations, and group size."
},
{
"name": "45 Seater Bus for School Trip Shirdi",
"description": "45 Seater Bus for School Trip Shirdi provides group transportation for educational tours, excursions, field visits, and school outings. Schools can organize the journey according to student and teacher requirements, planned stops, destination, pickup locations, and travel schedule."
},
{
"name": "45 Seater Bus for Pilgrimage Shirdi",
"description": "45 Seater Bus for Pilgrimage Shirdi is a convenient option for devotees traveling together to religious destinations. It can support temple tours, multi-location pilgrimage plans, group darshan trips, and customized religious journeys departing from Shirdi."
},
{
"name": "45 Seater Bus for Events Shirdi",
"description": "45 Seater Bus for Events Shirdi helps organizers manage transportation for guests attending exhibitions, conferences, cultural programs, parties, social gatherings, and other events. Group transfers can be arranged between hotels, venues, pickup points, and return destinations."
},
{
"name": "45 Seater AC Bus Shirdi",
"description": "45 Seater AC Bus Shirdi offers a spacious air-conditioned travel option for groups requiring comfortable transportation. It can be arranged for long-distance tours, sightseeing, family travel, corporate outings, weddings, pilgrimages, and event transportation."
},
{
"name": "45 Seater Luxury Bus Shirdi",
"description": "45 Seater Luxury Bus Shirdi is an appropriate choice for groups seeking a more premium and comfortable travel arrangement. The spacious bus can be used for corporate tours, family vacations, weddings, special events, sightseeing programs, and outstation journeys."
},
{
"name": "45 Seater Bus One Way Shirdi",
"description": "45 Seater Bus One Way Shirdi is useful when a large group needs transportation from Shirdi to a selected destination without requiring the bus for the return journey. The trip can be scheduled based on the preferred departure time, route, passenger count, and destination."
},
{
"name": "45 Seater Bus Round Trip Shirdi",
"description": "45 Seater Bus Round Trip Shirdi allows groups to plan transportation for both onward and return travel in a single arrangement. It is suitable for sightseeing tours, family vacations, pilgrimages, corporate outings, weddings, and multi-day group trips."
},
{
"name": "45 Seater Bus Airport Transfer Shirdi",
"description": "45 Seater Bus Airport Transfer Shirdi is suitable for large groups requiring coordinated transportation between Shirdi and nearby airports. The spacious vehicle can accommodate groups along with their travel luggage for scheduled airport pickup and drop requirements."
},
{
"name": "affordable 45 Seater Bus Rental Shirdi",
"description": "Affordable 45 Seater Bus Rental Shirdi provides a practical group transportation option for travelers looking to manage the overall cost of a large journey. Rental arrangements can be planned around the route, distance, travel duration, passenger requirements, and type of trip."
},
{
"name": "best 45 Seater Bus Hire Shirdi",
"description": "Best 45 Seater Bus Hire Shirdi is suitable for groups looking for spacious and convenient transportation for different travel purposes. It can be arranged for family tours, corporate trips, weddings, school excursions, pilgrimages, events, airport transfers, and outstation journeys."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 45 seater bus rental and group transportation solutions in Shirdi for local and outstation journeys. Customers can arrange buses for family trips, pilgrimages, weddings, corporate travel, school tours, sightseeing, events, airport transfers, and customized group itineraries."
}
],
"tableData": [
["45 Seater Bus on Rent in Shirdi", "45 Seater Bus Rental Shirdi"],
["45 Seater Bus Hire Shirdi", "45 Seater Tourist Bus Shirdi"],
["45 Seater Bus Booking Shirdi", "45 Seater Bus with Driver Shirdi"],
["45 Seater Bus for Outstation Shirdi", "45 Seater Bus for Family Trip Shirdi"],
["45 Seater Bus for Wedding Shirdi", "45 Seater Bus for Corporate Trip Shirdi"],
["45 Seater Bus for School Trip Shirdi", "45 Seater Bus for Pilgrimage Shirdi"],
["45 Seater Bus for Events Shirdi", "45 Seater AC Bus Shirdi"],
["45 Seater Luxury Bus Shirdi", "45 Seater Bus One Way Shirdi"],
["45 Seater Bus Round Trip Shirdi", "45 Seater Bus Airport Transfer Shirdi"],
["affordable 45 Seater Bus Rental Shirdi", "best 45 Seater Bus Hire Shirdi"],
["Sai Shirdi Cabs", "45 Seater Bus on Rent in Shirdi"]
]
,








whychoose: [ 

    {  

        WhyChooseheading: "45 Seater Bus on Rent in Shirdi for Large Group Travel",  

        WhyChoosedescription: "Sai Shirdi Cabs provides 45 Seater Bus rental services in Shirdi for large pilgrimage groups, families, tourists, school and college groups, corporate teams, wedding guests, and other large groups. A 45 Seater Bus can be arranged for Sai Baba Darshan, Shirdi sightseeing, religious tours, events, airport and railway station transfers, outstation journeys, and multi-day group travel."  

    },  

    {  

        WhyChooseheading: "Spacious 45 Seater Bus Rental for Group Transportation",  

        WhyChoosedescription: "A 45 Seater Bus provides a convenient transportation option for large groups travelling together in and around Shirdi. Instead of arranging several smaller vehicles, groups can coordinate their journey through one larger bus for hotel transfers, temple visits, sightseeing programs, events, railway station pickups, airport transfers, and planned outstation travel."  

    },  

    {  

        WhyChooseheading: "45 Seater Bus for Sai Baba Darshan in Shirdi",  

        WhyChoosedescription: "Pilgrimage groups visiting Shirdi can rent a 45 Seater Bus for Sai Baba Darshan and other religious visits. The bus can be used to coordinate transportation for devotees travelling together between their accommodation, temple areas, parking locations, railway station, and other planned pilgrimage destinations during their Shirdi visit."  

    },  

    {  

        WhyChooseheading: "45 Seater Bus for Shirdi Sightseeing Tours",  

        WhyChoosedescription: "Tourists and family groups can hire a 45 Seater Bus for sightseeing in Shirdi and nearby destinations. The travel plan can include religious attractions, local sightseeing points, nearby pilgrimage locations, and other places selected by the group, making it suitable for organized day tours and longer sightseeing schedules."  

    },  

    {  

        WhyChooseheading: "45 Seater Bus for Railway Station & Airport Transfers",  

        WhyChoosedescription: "Sai Shirdi Cabs can arrange 45 Seater Bus transportation for large groups requiring railway station or airport pickup and drop services. Group transfers can be planned according to arrival and departure schedules, passenger requirements, luggage needs, hotel locations, and other destinations included in the travel itinerary."  

    },  

    {  

        WhyChooseheading: "45 Seater Bus Rental for Weddings and Events",  

        WhyChoosedescription: "A 45 Seater Bus can be rented in Shirdi for weddings, receptions, religious functions, corporate events, family gatherings, conferences, and other group occasions. Event organizers can use the bus to coordinate guest transportation between hotels, venues, railway stations, parking areas, and other locations according to the planned event schedule."  

    },  

    {  

        WhyChooseheading: "45 Seater Bus for Outstation Trips from Shirdi",  

        WhyChoosedescription: "Large groups can book a 45 Seater Bus from Shirdi for outstation journeys to cities, tourist destinations, and pilgrimage locations such as Nashik, Mumbai, Pune, Trimbakeshwar, Shani Shingnapur, Aurangabad, and other destinations. It can be suitable for family tours, religious circuits, school trips, corporate outings, and multi-city travel plans."  

    },  

    {  

        WhyChooseheading: "Book 45 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs",  

        WhyChoosedescription: "To arrange a 45 Seater Bus in Shirdi, provide Sai Shirdi Cabs with your pickup location, destination, travel date, number of passengers, luggage requirements, rental duration, sightseeing plans, and one-way or round-trip requirement. Based on the complete travel details, the bus rental can be planned according to your group's transportation needs."  

    }  

]  


};

const faqData = [

{

question: "Can I rent a 45 Seater Bus in Shirdi?",

answer: "Yes, Sai Shirdi Cabs provides 45 Seater Bus rental services in Shirdi for pilgrimage groups, families, tourists, corporate teams, wedding guests, school groups, and other large groups."

},

{

question: "Is a 45 Seater Bus suitable for Sai Baba Darshan?",

answer: "Yes, a 45 Seater Bus can be arranged for large groups visiting Sai Baba Temple and nearby religious destinations according to their planned travel schedule."

},

{

question: "Can I book a 45 Seater Bus for Shirdi sightseeing?",

answer: "Yes, groups can book a 45 Seater Bus for Shirdi sightseeing and nearby attractions based on their preferred destinations, travel duration, and sightseeing itinerary."

},

{

question: "Can I book a 45 Seater Bus for airport pickup and drop?",

answer: "Yes, a 45 Seater Bus can be arranged for airport pickup and drop services for large groups according to flight timings, passenger requirements, luggage, and the required transfer locations."

},

{

question: "Can I get a 45 Seater Bus from Shirdi Railway Station?",

answer: "Yes, Sai Shirdi Cabs can arrange group transportation from Shirdi Railway Station using a 45 Seater Bus according to train arrival or departure schedules and the group's destination."

},

{

question: "Can I rent a 45 Seater Bus for a wedding in Shirdi?",

answer: "Yes, a 45 Seater Bus can be booked for wedding guests, family members, receptions, religious functions, and other event-related transportation requirements in Shirdi."

},

{

question: "Can I use a 45 Seater Bus for an outstation trip from Shirdi?",

answer: "Yes, a 45 Seater Bus can be used for outstation group travel from Shirdi to different cities, tourist destinations, pilgrimage places, and other locations based on the planned route."

},

{

question: "Can I rent a 45 Seater Bus for multiple days?",

answer: "Yes, multi-day 45 Seater Bus rental can be arranged for extended pilgrimage tours, family vacations, sightseeing trips, corporate tours, school excursions, religious circuits, and multi-city journeys."

},

{

question: "Can a 45 Seater Bus be booked for corporate travel?",

answer: "Yes, companies can use a 45 Seater Bus for corporate events, employee group transportation, conferences, meetings, business tours, company outings, and other organized group travel requirements."

},

{

question: "How can I book a 45 Seater Bus on Rent in Shirdi?",

answer: "You can contact Sai Shirdi Cabs with your pickup point, destination, travel date, passenger count, luggage details, rental duration, sightseeing or event requirements, and one-way or return preference to arrange the 45 Seater Bus service."

}

];

const testimonials = [

{

id: 1,

name: "Mr. Amit Deshmukh",

feedback: "We rented a 45 Seater Bus in Shirdi for our pilgrimage group and used it for Sai Baba Darshan and nearby sightseeing. Having everyone travel together made the entire trip easier to coordinate and kept our group organized throughout the journey.",

rating: 5

},

{

id: 2,

name: "Mrs. Priya Patil",

feedback: "Our family group booked a 45 Seater Bus for an event in Shirdi. The larger vehicle was convenient for transporting guests between the hotel, venue, railway station, and other planned locations without having to manage several separate cars.",

rating: 5

}

];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/45-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book a 45 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. Our 45 Seater Bus is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimages, weddings, corporate trips, school trips, airport transfers, railway station transfers, and outstation travel. Get a well-maintained bus with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/45-seater-bus-on-rent-in-shirdi"
  }
};







    return (
        <div>
<Helmet>
  <title>45 Seater Bus on Rent in Shirdi | 45 Seater Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 45 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, weddings, corporate trips, school trips and outstation journeys. Get a spacious bus with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="45 Seater Bus on Rent in Shirdi, 45 Seater Bus Rental Shirdi, 45 Seater Bus Hire Shirdi, 45 Seater Tourist Bus Shirdi, 45 Seater Bus Booking Shirdi, 45 Seater Bus with Driver Shirdi, 45 Seater Bus for Outstation Shirdi, 45 Seater Bus for Family Trip Shirdi, 45 Seater Bus for Wedding Shirdi, 45 Seater Bus for Corporate Trip Shirdi, 45 Seater Bus for School Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Fourseaterbusonrentinshirdi;